/**
 * Created by Omar Alejandro Leonor Avalos on 2017-09-22.
 */
import { GLOBAL_NOTIFY } from './global.types';
import { SnackBar } from './components/widgets';

export const notifyGlobally = (payload) => {
    return {
        type: GLOBAL_NOTIFY,
        payload
    };
};

export const showSuccessMessage = (message) => {
    return showMessage(SnackBar.SUCCESS, message);
};

export const showErrorMessage = (message) => {
    return showMessage(SnackBar.ERROR, message);
};

export const showWarningMessage = (message) => {
    return showMessage(SnackBar.WARNING, message);
};

export const showInfoMessage = (message) => {
    return showMessage(SnackBar.INFO, message);
};

const showMessage = (type, message) => {
    return notifyGlobally({
        path: 'snackbarConfig',
        value: {
            open: true,
            message,
            type
        }
    });
};




// WEBPACK FOOTER //
// ./global.actions.js